import { render, staticRenderFns } from "./CourseViewUserPermissionsCard.vue?vue&type=template&id=5d84bd12&scoped=true&"
import script from "./CourseViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./CourseViewUserPermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseViewUserPermissionsCard.vue?vue&type=style&index=0&id=5d84bd12&lang=scss&scoped=true&"
import style1 from "./CourseViewUserPermissionsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84bd12",
  null
  
)

export default component.exports